import request from '@/utils/request'

export function addDelivery(data) {
  return request({
    url: `/tbPositionDelivery/addDelivery`,
    method: 'post',
    data
  })
}
